export enum TypeCreateClient {
  CPF = "CPF",
  CNPJ = "CNPJ"
}
